export const API_HOST = 'https://api.text.bnamic.com';
//export const API_HOST = 'http://localhost:8084';
export const API_PATH = '/';



// WEBPACK FOOTER //
// ./src/config/_entrypoint.js